import { Scope, Severity, Event } from "@sentry/browser";
import { SentryService } from "./sentry.service";
import { IErrorConfig, ILogConfig, ILogger } from "../types";


function LogCaptureHandler(sentryService: SentryService): ILogger {
    function loggerFunc(moduleName: string, level: string, e?: any) {
        Sentry.withScope(sentryService.getScope(moduleName, function (scope: Scope) {
            scope.setLevel(Severity.fromString(level));
            Sentry.captureException(e);
        }));
    }

    loggerFunc.log = (configs: ILogConfig) => {
        Sentry.withScope(sentryService.getScope(configs.module, function (scope: Scope) {
            scope.setLevel(Severity.Log);

            if (configs.transaction) {
                scope.setTransactionName(configs.transaction);
            }
            if (configs.context) {
                scope.setContext("customContext", configs.context);
            }
            if (configs.reason) {
                scope.setExtra("reason", configs.reason);
            }

            scope.setExtra("errorType", "ignored");

            Sentry.captureMessage(configs.title);
        }));

    }

    loggerFunc.error = (configs: IErrorConfig) => {
        Sentry.withScope(sentryService.getScope(configs.module, function (scope: Scope) {
            scope.setLevel(Severity.Error);

            if (configs.transaction) {
                scope.setTransactionName(configs.transaction);
            }
            if (configs.context) {
                scope.setContext("customContext", configs.context);
            }
            if (configs.error) {
                scope.setExtra("exception", configs.error);
            }

            scope.setExtra("errorType", "for_review");

            Sentry.captureMessage(configs.title);
        }));
    }

    return loggerFunc as ILogger;
}

let injectableLogHandler = ['$sentry', LogCaptureHandler]

export { injectableLogHandler }